import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  FormCheckboxMultiple,
  ICheckboxOption,
} from "src/core/components/custom-ui/form-checkbox-multiple";
import { FormInput } from "src/core/components/custom-ui/form-input";
import { Button } from "src/core/components/ui/button";
import { DialogFooter } from "src/core/components/ui/dialog";
import { Form } from "src/core/components/ui/form";
import {
  AddStakeholderBasicFormValues,
  defaultAddStakeholderBasicValues,
} from "src/core/forms/stakeholder/addStakeholderBasic.schema";

type UseAddStakeholderBasicFormProps = {
  form: UseFormReturn<AddStakeholderBasicFormValues>;
  onSubmit: (data: AddStakeholderBasicFormValues) => void;
  isLoading: boolean;
  roleOptions: ICheckboxOption[];
  setOpen: (open: boolean) => void;
};

/**
 * Composant pour ajouter une partie prenante (stakeholder) à un dossier.
 * Version basique avec seulement le rôle et le nom et le prénom.
 */
export function AddStakeholderBasicForm({
  form,
  onSubmit,
  isLoading,
  roleOptions,
  setOpen,
}: UseAddStakeholderBasicFormProps) {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FormCheckboxMultiple
          control={form.control}
          name="roles"
          required
          label={t("form.addStakeholderFull.role")}
          options={roleOptions}
        />
        <div className="flex flex-row">
          <FormInput
            control={form.control}
            name="firstName"
            required
            label={t("form.addStakeholderBasic.firstName")}
            className="w-[160px]"
          />
          <div className="ml-[40px]">
            <FormInput
              control={form.control}
              name="lastName"
              required
              label={t("form.addStakeholderBasic.lastName")}
              className="w-[160px]"
            />
          </div>
        </div>

        <DialogFooter>
          <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
            {t("form.addStakeholderBasic.submit")}
          </Button>
          <Button
            variant="link"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
              form.reset(defaultAddStakeholderBasicValues);
            }}
          >
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
}
